import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { checkExportStatus } from '@cognitoforms/api/services/organization-audit-log-service';
import notify from 'src/utilities/notify';

export const useOrganizationAuditLogExportDownload = () => {
	const route = useRoute();
	const downloadUrl = ref<string>();

	onMounted(async () => {
		const exportId = route.query.organizationAuditLogExportId as string;
		if (!exportId)
			return;

		let statusResponse;
		try {
			statusResponse = await checkExportStatus(exportId);
		}
		catch {
			notify('This audit log export is no longer available to download.', 'error');
			return;
		}

		const resolvedDownloadUrl = statusResponse?.downloadUrl;
		if (!resolvedDownloadUrl)
			return;

		downloadUrl.value = resolvedDownloadUrl;

		// Automatically start the download
		const link = Object.assign(document.createElement('a'), { href: resolvedDownloadUrl, download: '' });
		document.body.append(link);
		link.click();
		link.remove();
	});

	return { downloadUrl };
};
